<div id="carousel" class="carousel slide" data-ride="carousel">
    <div class="carousel-inner">
        <div class="carousel-item active">
            <img class="d-block w-100" src="https://via.placeholder.com/1080" alt="First slide">
        </div>
        <div class="carousel-item">
            <img class="d-block w-100" src="https://via.placeholder.com/1080" alt="Second slide">
        </div>
        <div class="carousel-item">
            <img class="d-block w-100" src="https://via.placeholder.com/1080" alt="Third slide">
        </div>
    </div>
    <a class="carousel-control-prev" href="#carouselControls" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">{{'Previous' | translateOrgSpecific}}</span>
    </a>
    <a class="carousel-control-next" href="#carouselControls" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">{{'Next' | translateOrgSpecific}}</span>
    </a>
</div>

<div class="container">
    <div class="row justify-content-center mt-4">
        <div class="col-md-6">
            <app-get-help></app-get-help>
        </div>
    </div>
</div>

<div class="container">
    <div class="row mt-4">
        <div class="col-md-8">
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Esse dicta dolorum corporis alias quia vero nam
            assumenda repudiandae
            obcaecati mollitia, sit quidem similique, nostrum ullam nobis architecto, quaerat aspernatur quibusdam.
            Lorem
            ipsum dolor, sit amet consectetur adipisicing elit. Provident architecto minima sit! Laboriosam impedit
            harum
            optio minima deleniti omnis magni mollitia a possimus at. Rem doloribus aliquid earum. Sequi, odio. Lorem
            ipsum
            dolor sit amet consectetur adipisicing elit. Illum ipsam laboriosam hic quia cumque? Et quos adipisci
            architecto
            est mollitia harum dolor. Cupiditate nulla tempore saepe, libero quae quisquam ex. Lorem ipsum dolor sit
            amet
            consectetur adipisicing elit. Autem, ipsum fuga perspiciatis placeat architecto optio officia dolorem, at
            rerum
            itaque molestias temporibus quis nostrum laudantium, natus ducimus cumque dolores? Saepe. Lorem ipsum dolor
            sit
            amet consectetur adipisicing elit. Eum dignissimos placeat in perferendis, iure tempore? Veniam a, culpa
            cumque
            autem dolorum recusandae quis hic dolores aliquid, nostrum ullam. Dicta, quo?
        </div>

        <div class="col-md-4">
            <img src="https://via.placeholder.com/1080" class="img-fluid">
        </div>
    </div>
</div>

<div class="container">
    <div class="row">
        <div class="col-md-12 mt-5">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto perspiciatis eligendi laborum vero tempora
            eaque adipisci
            harum quam modi non unde eos, temporibus fuga nostrum excepturi aliquam voluptatibus dolorem deleniti. Lorem
            ipsum dolor sit amet consectetur adipisicing elit. Iure esse ex nisi officiis facilis deserunt sequi
            blanditiis
            ipsa quis, omnis ab, optio amet, sit saepe ratione alias cumque aspernatur eligendi? Lorem ipsum dolor sit
            amet
            consectetur adipisicing elit. Eligendi corrupti ipsum nostrum saepe ad quis doloribus soluta sapiente eos et
            fugit sed quasi quibusdam perspiciatis ex quam perferendis, veritatis labore!
        </div>
    </div>
</div>

<div class="container">
    <div class="row">
        <div class="col-md-4 pt-5">
            <img src="https://via.placeholder.com/1080" class="img-fluid">
        </div>
        <div class="col-md-4 mt-5">
            <img src="https://via.placeholder.com/1080" class="img-fluid">
        </div>
        <div class="col-md-4 mt-5">
            <img src="https://via.placeholder.com/1080" class="img-fluid">
        </div>
    </div>
</div>

<div class="container">
    <div class="row">
        <div class="col-md-12 mt-5">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto perspiciatis eligendi laborum vero tempora
            eaque adipisci
            harum quam modi non unde eos, temporibus fuga nostrum excepturi aliquam voluptatibus dolorem deleniti. Lorem
            ipsum dolor sit amet consectetur adipisicing elit. Iure esse ex nisi officiis facilis deserunt sequi
            blanditiis
            ipsa quis, omnis ab, optio amet, sit saepe ratione alias cumque aspernatur eligendi? Lorem ipsum dolor sit
            amet
            consectetur adipisicing elit. Eligendi corrupti ipsum nostrum saepe ad quis doloribus soluta sapiente eos et
            fugit sed quasi quibusdam perspiciatis ex quam perferendis, veritatis labore!
        </div>
    </div>
</div>